import { useMutation, useQueryClient } from 'react-query';
import { payment_remark_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import { paymentRemarkKeys } from '../../cache-keys/paymentRemarkKeys.tsx';
import { Broker } from '@axo/shared/data-access/types/broker';

export function useTriggerCreditCheck() {
  const client = useQueryClient();
  const api = useAPI();

  return useMutation(
    ({
      personID,
      marketCountry,
      loanApplicationID,
      broker,
    }: {
      personID: string;
      marketCountry: string;
      loanApplicationID: string;
      broker: Broker;
    }) =>
      payment_remark_api.triggerCreditCheck(api)({
        personID,
        marketCountry,
        loanApplicationID,
        broker,
      }),
    {
      onSuccess: (_, { personID }) =>
        Promise.all([
          client.invalidateQueries(
            paymentRemarkKeys.root({
              personID,
            }),
          ),
        ]),
    },
  );
}
